import React from 'react';

export const RegisIcon1 = () => {
  return (
    <>
      <svg
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 5.5C18.55 5.5 17.74 6.94 18.07 8.01L14.52 11.57C14.22 11.48 13.78 11.48 13.48 11.57L10.93 9.02C11.27 7.95 10.46 6.5 9 6.5C7.55 6.5 6.73 7.94 7.07 9.02L2.51 13.57C1.44 13.24 0 14.05 0 15.5C0 16.6 0.9 17.5 2 17.5C3.45 17.5 4.26 16.06 3.93 14.99L8.48 10.43C8.78 10.52 9.22 10.52 9.52 10.43L12.07 12.98C11.73 14.05 12.54 15.5 14 15.5C15.45 15.5 16.27 14.06 15.93 12.98L19.49 9.43C20.56 9.76 22 8.95 22 7.5C22 6.4 21.1 5.5 20 5.5Z"
          fill="#5AC4B1"
        />
        <path
          d="M14 6.5L14.94 4.43L17 3.5L14.94 2.57L14 0.5L13.08 2.57L11 3.5L13.08 4.43L14 6.5Z"
          fill="#5AC4B1"
        />
        <path
          d="M2.5 8.5L3 6.5L5 6L3 5.5L2.5 3.5L2 5.5L0 6L2 6.5L2.5 8.5Z"
          fill="#5AC4B1"
        />
      </svg>
    </>
  );
};
